import { NavLink, useLocation, Link } from 'react-router-dom';
import { FiMenu } from 'react-icons/fi';
import { RiLogoutCircleRLine } from 'react-icons/ri';
import { AiOutlineClose } from 'react-icons/ai';
import { HiUsers, HiOutlineUsers } from 'react-icons/hi';
import { useEffect, useRef, useState } from 'react';
import {
  MdCampaign,
  MdDashboard,
  MdOutlineCampaign,
  MdOutlineDashboard,
  MdHeadsetMic,
  MdOutlineHeadsetMic,
} from 'react-icons/md';
import { FaHandshake, FaRegHandshake } from 'react-icons/fa';
import {
  Container,
  Menu,
  Wrapper,
  Header,
  Content,
  Navbar,
  Logo,
} from './styles';
import { useAuth } from '../../hooks/auth';
import { Notification } from './components/Notification';
import { Theme } from './components/Theme';
import { Search } from './components/Search';
import { Profile } from './components/Profile';

const items = [
  {
    id: 0,
    title: 'Dashboard',
    Icon: MdDashboard,
    route: '/dashboard',
    IconOutline: MdOutlineDashboard,
    permission: ['CLIENT', 'ADMIN'],
  },
  {
    id: 1,
    title: 'Clientes',
    Icon: FaHandshake,
    route: '/clients',
    IconOutline: FaRegHandshake,
    permission: ['ADMIN', 'CLIENT'],
  },
  {
    id: 2,
    title: 'Campanhas',
    Icon: MdCampaign,
    route: '/campaigns',
    IconOutline: MdOutlineCampaign,
    permission: ['CLIENT', 'ADMIN'],
  },
  {
    id: 3,
    title: 'Influenciadores',
    Icon: MdHeadsetMic,
    route: '/influencers',
    IconOutline: MdOutlineHeadsetMic,
    permission: ['CLIENT', 'ADMIN'],
  },
  {
    id: 4,
    title: 'Usuários',
    Icon: HiUsers,
    route: '/users',
    IconOutline: HiOutlineUsers,
    permission: ['ADMIN'],
  },
];

export const DefaultLayout: React.FC = ({ children }) => {
  const { signOut, user } = useAuth();
  const location = useLocation();
  const navbarRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const itemsFiltered = items.filter(item =>
    item.permission.some(tst => tst === user.role),
  );

  const handleOpenMenu = () => {
    setVisible(true);
  };

  const handleCloseMenu = () => {
    setVisible(false);
  };

  useEffect(() => {
    function handleClickOverlay(event: MouseEvent): void {
      if (
        navbarRef.current &&
        event.target instanceof Node &&
        !navbarRef.current.contains(event.target)
      ) {
        setVisible(false);
      }
    }

    if (visible) {
      document.addEventListener('mouseup', handleClickOverlay);
    }
  }, [visible]);

  return (
    <Container>
      <Menu visible={visible}>
        <Navbar
          ref={navbarRef}
          visible={visible}
          className="flex-column justify-content-between"
        >
          <div>
            <Logo className="mb-3">
              <Link to="/dashboard">
                <img
                  src="https://ignisdigital.tec.br/logo-blue.png"
                  alt="Ignis Digital"
                />
              </Link>
              <button
                type="button"
                className="btn-actions-mobile"
                onClick={handleCloseMenu}
              >
                <AiOutlineClose />
              </button>
            </Logo>
            <ul>
              {itemsFiltered.map(item => (
                <li key={item.id}>
                  <NavLink to={item.route} activeClassName="selected">
                    {location.pathname.startsWith(item.route) ? (
                      <item.Icon />
                    ) : (
                      <item.IconOutline />
                    )}
                    <span>{item.title}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          <button type="button" onClick={signOut} className="btn-menu">
            <RiLogoutCircleRLine size={20} />
            Sair
          </button>
        </Navbar>
      </Menu>

      <Header visible={visible}>
        <button
          type="button"
          onClick={handleOpenMenu}
          className="bg-transparent border-0 mr-3"
          id="btn-open-menu"
        >
          <FiMenu size={24} />
        </button>
        <div className="d-flex align-items-center">
          <Search />
          <Theme />
          <Notification />
          <Profile />
        </div>
      </Header>

      <Wrapper>
        <Content>{children}</Content>
      </Wrapper>
    </Container>
  );
};
